
    // IMPORTS
    import { computed, defineComponent, PropType, ref, watch } from 'vue';
    import { useUserStore } from '@/store/user';

    import { AuthenticationApi, buildLocalization, DEBUG_ENABLED } from '@/util';

    export default defineComponent({
        name: 'topBanner',

        props: {
            title: { type: String as PropType<string | null>, required: false, default: () => null },
            showBackButton: { type: Boolean as PropType<boolean>, required: false, default: () => false },
            showLogOff: { type: Boolean as PropType<boolean>, required: false, default: () => false }
        },

        setup() {
            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/
            const { localize } = buildLocalization()
            const userStore = useUserStore()

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const dbName = ref<string | null>(null)
            const publicData = { dbName }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const showDbName = computed(() => DEBUG_ENABLED && userStore.isAdmin)
            const siteTitle = computed(() => localize('PortalTitle'))
            const computedData = { showDbName, siteTitle }


            /********************************************************************************************************************
             WATCHERS
             ********************************************************************************************************************/
            watch(showDbName,
                () => {
                    if (showDbName.value) {
                        (new AuthenticationApi).currentDatabase().then(response => dbName.value = response.data.split('-').reverse()[0].toUpperCase())
                    }
                    else {
                        dbName.value = null
                    }
                },
                { immediate: true }
            )

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData }
        }
    });
